const routeStopUtils = {
  data: function () {
    return {
      stopIcon: {
        container: {
          pending: 'schedule',
          emptied: 'check_circle',
          skipped: 'fast_forward',
        },
        dumping: 'download_for_offline',
      },
    }
  },
  methods: {
    getStopIcon(routeStop) {
      if (routeStop.position_type === 'container') {
        return this.stopIcon['container'][routeStop.status]
      }
      if (routeStop.position_type === 'dumping') {
        return this.stopIcon['dumping']
      }
      return null
    },
  },
}

export default routeStopUtils
